/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector2dPb } from "../eigen_lcm/Vector2d";

export const protobufPackage = "shape_map";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface PolygonPb {
  add: boolean;
  vertices: Vector2dPb[];
  minHeight: number;
  maxHeight: number;
}

function createBasePolygonPb(): PolygonPb {
  return { add: false, vertices: [], minHeight: 0, maxHeight: 0 };
}

export const PolygonPb = {
  encode(message: PolygonPb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.add === true) {
      writer.uint32(8).bool(message.add);
    }
    for (const v of message.vertices) {
      Vector2dPb.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.minHeight !== 0) {
      writer.uint32(25).double(message.minHeight);
    }
    if (message.maxHeight !== 0) {
      writer.uint32(33).double(message.maxHeight);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PolygonPb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePolygonPb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.add = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.vertices.push(Vector2dPb.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.minHeight = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.maxHeight = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PolygonPb {
    return {
      add: isSet(object.add) ? globalThis.Boolean(object.add) : false,
      vertices: globalThis.Array.isArray(object?.vertices)
        ? object.vertices.map((e: any) => Vector2dPb.fromJSON(e))
        : [],
      minHeight: isSet(object.minHeight) ? globalThis.Number(object.minHeight) : 0,
      maxHeight: isSet(object.maxHeight) ? globalThis.Number(object.maxHeight) : 0,
    };
  },

  toJSON(message: PolygonPb): unknown {
    const obj: any = {};
    if (message.add === true) {
      obj.add = message.add;
    }
    if (message.vertices?.length) {
      obj.vertices = message.vertices.map((e) => Vector2dPb.toJSON(e));
    }
    if (message.minHeight !== 0) {
      obj.minHeight = message.minHeight;
    }
    if (message.maxHeight !== 0) {
      obj.maxHeight = message.maxHeight;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PolygonPb>, I>>(base?: I): PolygonPb {
    return PolygonPb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PolygonPb>, I>>(object: I): PolygonPb {
    const message = createBasePolygonPb();
    message.add = object.add ?? false;
    message.vertices = object.vertices?.map((e) => Vector2dPb.fromPartial(e)) || [];
    message.minHeight = object.minHeight ?? 0;
    message.maxHeight = object.maxHeight ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
